// Application constants

// Backend base URL (without /api)
// Set REACT_APP_BACKEND_URL in .env for local dev (e.g. http://localhost:8000)
// export const BACKEND_URL = "http://localhost:8000";
export const BACKEND_URL = "https://api-safar.safarcore.com";

// API base URL (with /api)
export const API_BASE_URL = `${BACKEND_URL}/api`;

/** Public marketing site */
export const SAFARCORE_SITE_URL = "https://safarcore.com";

/** App shell logo (also referenced as favicon in public/index.html) */
export const BRAND_LOGO_PATH = "/images/SafarCoreLogo.png";

// Log the API URL for debugging (remove in production)
if (process.env.NODE_ENV === "development") {
  console.log("API Base URL:", API_BASE_URL);
}

export const USER_ROLES = {
  ADMIN: "admin",
  SALES: "sales",
  FINANCE: "finance",
  MANAGEMENT: "management",
};

export const INVOICE_STATUS = {
  DRAFT: "draft",
  PENDING_APPROVAL: "pending_approval",
  APPROVED: "approved",
  REJECTED: "rejected",
};

export const PAYMENT_STATUS = {
  UNPAID: "unpaid",
  PARTIAL: "partial",
  PAID: "paid",
};

export const CURRENCY = {
  OMR: "OMR",
};

export const DEFAULT_VAT_PERCENTAGE = 5.0;

/** Default bank details shown on invoices (can be overridden via settings later) */
export const DEFAULT_BANK_DETAILS = {
  bankName: "Bank Muscat",
  address: "PC 115 MSQ 895, Muscat, Sultanate of Oman",
  branch: "Bausher",
  beneficiaryName: "CANARY INT TRAVEL AND TOURISM",
  iban: "OM030270329027833640018",
  accountNo: "0329-02783364-001-8",
  swiftCode: "BMUSOMRXXXX",
};

/** Payment mode options for Record Payment */
export const PAYMENT_MODES = [
  { value: "CASH", label: "Cash" },
  { value: "CHEQUE", label: "Cheque" },
  { value: "VISA_DEBIT_OR_CREDIT_CARD", label: "Visa Debit or Credit Card" },
  { value: "LPO", label: "LPO" },
  { value: "BANK_TRANSFER", label: "Bank Transfer" },
];

// export const REACT_APP_STRIPE_PUBLISHABLE_KEY =
//   pk_test_51SgY9qSZIhz0iqBodCXaglqbrz66umV3ZKez7WB2BIPUVHMwu1dSAdUoO1YjMEJBVHMap08ItL0R174pe25fGrkG0091P8Kn2L;
